/** Splitter telefonnumre modtaget som "12345678;87654321" fra appserver. */
export function splitTelefonnumre(telefonnrSamlet: string | null | undefined): [string, string] {
    if (!telefonnrSamlet?.trim()) {
        return ["", ""];
    }

    const [telefonnr, ...resterendeTelefonnumre] = telefonnrSamlet.split(";").map((telefonnrPart) => telefonnrPart.trim());
    return [telefonnr ?? "", resterendeTelefonnumre.filter(Boolean).join(";")];
}

function normaliserTelefon(value: string | null | undefined): string {
    return String(value ?? "").replace(/\D/g, "");
}

export interface BeboerTelefonKilder {
    telefonnr?: string | null;
    telefonnr2?: string | null;
    tlf?: string | null;
    tlf2?: string | null;
}

/** Sammenfatter beboer-telefon fra installation og getebrugerinfo. */
export function hentBeboerTelefonnumre(kilder: BeboerTelefonKilder): { telefon: string; telefon2: string } {
    let telefon = (kilder.telefonnr ?? kilder.tlf ?? "").trim();
    let telefon2 = (kilder.telefonnr2 ?? kilder.tlf2 ?? "").trim();

    if (telefon.includes(";")) {
        const [primær, sekundær] = splitTelefonnumre(telefon);
        telefon = primær;
        telefon2 = telefon2 || sekundær;
    }

    if (!telefon) {
        telefon = (kilder.tlf ?? "").trim();
    }
    if (!telefon2) {
        telefon2 = (kilder.tlf2 ?? "").trim();
    }

    if (normaliserTelefon(telefon2) && normaliserTelefon(telefon2) === normaliserTelefon(telefon)) {
        telefon2 = "";
    }

    return { telefon, telefon2 };
}

export function samlTelefonnumre(telefonnr: string | null | undefined, telefonnr2: string | null | undefined): string {
    const primartNummer = (telefonnr ?? "").trim();
    const sekundartNummer = (telefonnr2 ?? "").trim();

    if (!primartNummer && !sekundartNummer) {
        return "";
    }

    if (!sekundartNummer) {
        return primartNummer;
    }

    return `${primartNummer};${sekundartNummer}`;
}
